var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{attrs:{"searchWord":_vm.searchWord},on:{"click":_vm.search}},[_vm._v(_vm._s(_vm.searchWord))])}
var staticRenderFns = []

export { render, staticRenderFns }